export default {
  greeting: 'สวัสดี, {{name}}',
  greeting_morning: 'อรุณสวัสดิ์, {{name}}',
  greeting_afternoon: 'สวัสดีตอนบ่าย, {{name}}',
  greeting_evening: 'สวัสดีตอนเย็น, {{name}}',
  lease_card_title: 'สัญญาเช่าปัจจุบัน',
  property: 'ที่พัก',
  unit: 'ห้อง',
  period: 'ช่วงเวลา',
  no_active_lease: 'ไม่มีสัญญาเช่าที่ใช้งานอยู่',
  unpaid_invoices: 'ใบแจ้งหนี้ค้างชำระ',
  pending_parcels: 'พัสดุรอรับ',
  my_vehicles: 'ยานพาหนะของฉัน',
  pay_now: 'ชำระเงิน',
  view_parcels: 'ดู',
  view_vehicles: 'ดู',
  invoices_count: '{{count}} ใบ',
  parcels_count: '{{count}} ชิ้น',
  vehicles_count: '{{count}} คัน',
  view_lease_agreement: 'ดูสัญญาเช่า',
  lease_pdf_unavailable_title: 'ไม่พบเอกสารสัญญาเช่า',
  lease_pdf_unavailable_body: 'ไม่พบไฟล์สัญญาเช่าที่จัดเก็บไว้ กรุณาแจ้งผู้ดูแลอาคารให้สร้างไฟล์ใหม่ หรืออัปโหลดภาพสแกนของสัญญาฉบับจริงที่ลงนามแล้ว',
  announcements_title: 'ประกาศ',
  no_announcements: 'ยังไม่มีประกาศในขณะนี้',
  announcement_not_found: 'ไม่พบประกาศ',
  read_more: 'อ่านเพิ่มเติม',
  published: 'เผยแพร่',
  expires: 'หมดอายุ',
  my_rewards: 'รางวัล',
  rewards_points: '{{count}} คะแนน',
  win_pickup: 'เรียกวิน',
  win_pickup_subtitle: 'เรียกวินมอเตอร์ไซค์รับจ้าง',
  // EP-135 Tier 1a — meeting card for shared owners + dual-role persons
  meetings_card_title: 'การประชุม',
  meetings_card_subtitle_one: '1 หน่วยที่ถือครอง',
  meetings_card_subtitle_other: '{{count}} หน่วยที่ถือครอง',
  // EP-156 T156-005 — add-friend card, shown only when liff.getFriendship()
  // reports the tenant is not yet a friend of the account's LINE OA.
  line_add_friend_title: 'รับใบแจ้งหนี้ทางแชท LINE',
  line_add_friend_subtitle: 'เพิ่ม {{account}} เป็นเพื่อน',
  line_add_friend_cta: 'เพิ่มเพื่อน',
}
